import { URLs } from '../../../helpers/urls';
import { SystemEnvs } from '../../envs';

export const base = 'auth';
export const login = URLs.combine(SystemEnvs.API_BASE_URL, base, 'login');
export const logout = URLs.combine(SystemEnvs.API_BASE_URL, base, 'logout');
export const info = `${base}/info`;
